<template>
  <v-container pa-4 grid-list-xs fluid background>
    <v-layout wrap pa-4 style="background-color:#ffffff;border-radius:10px;">
      <v-flex xs12 md12 >
        <v-card-text class="text-xs-left">
          <h2 class="card-title">{{$t('AccountProfile')}}</h2>
          <v-form ref="form" v-model="form_valid">
            <v-layout wrap>
              <v-flex xs12 md7>
                <v-text-field
                  class="purple-input"
                  :label="$t('user_name')"
                  v-model="form_model.user_code"
                  :rules="form_rules.user_code"
                  readonly
                />
              </v-flex>

              <v-flex xs12 md7>
                <v-text-field
                  class="purple-input"
                  :label="$t('email')"
                  v-model="form_model.email"
                  :rules="form_rules.email"
                  readonly
                />
              </v-flex>

              <!-- <v-flex xs12 text-xs-left>
                <v-btn
                  class="mx-0"
                  color="success"
                  round
                  @click="profileUpdate()"
                >{{$t('UpdateProfile')}}</v-btn>
              </v-flex> -->
            </v-layout>
          </v-form>
        </v-card-text>
      </v-flex>
      <v-flex xs12 md12>
        <v-card-text class="text-xs-left">
          <h2 class="card-title">{{$t('ACCOUNTPASSWORD')}}</h2>
          <v-form ref="form" v-model="password_valid">
            <v-layout wrap>
              <v-flex xs12 md7>
                <v-text-field
                  class="purple-input"
                  type="password"
                  :label="$t('oldpassword')"
                  v-model="password_model.old_password"
                  :rules="password_rules.old_password"
                />
              </v-flex>

              <v-flex xs12 md7>
                <v-text-field
                  class="purple-input"
                   type="password"
                  :label="$t('newpassword')"
                  v-model="password_model.new_password"
                  :rules="password_rules.new_password"
                />
              </v-flex>
              <v-flex xs12 md7>
                <v-text-field
                  class="purple-input"
                   type="password"
                  :label="$t('confirmpassword')"
                  v-model="password_model.confirm_password"
                  :rules="password_rules.confirm_password"
                />
              </v-flex>
              <v-flex xs12 text-xs-left>
                <v-btn
                  class="mx-0"
                  color="success"
                  round
                  @click="passwordUpdate()"
                >{{$t('UpdatePassword')}}</v-btn>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
      </v-flex>
    </v-layout>
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
/* eslint-disable */
import { mapState, mapActions } from "vuex";
import ProfileService from "@/services/ProfileService";
export default {
  data: () => ({
    form_valid: false,
    password_valid: false,
    form_model: {
      user_code: "",
      email: ""
    },
    password_model: {
      old_password: "",
      new_password: "",
      confirm_password: ""
    },
    password_rules: {
      old_password: [v => !!v || "do not empty."],
      new_password: [  (v) => !!v || 'กรุณากรอกข้อมูล.',
                    (v) => { const pattern = /^(?=.*[a-z,A-Z])(?=.*[0-9])(?=.{4,})/;
                             return pattern.test(v) || 'รหัสผ่านอย่างน้อย 4 ตัวอักษร มีอักษรภาษาอังกฤษอย่างน้อย 1 ตัว และตัวเลข เท่านั้น'
                 }],
      confirm_password: [  (v) => !!v || 'กรุณากรอกข้อมูล.',
                    (v) => { const pattern = /^(?=.*[a-z,A-Z])(?=.*[0-9])(?=.{4,})/;
                             return pattern.test(v) || 'รหัสผ่านอย่างน้อย 4 ตัวอักษร มีอักษรภาษาอังกฤษอย่างน้อย 1 ตัว และตัวเลข เท่านั้น'
                 }]
    },
    form_rules: {
      user_code: [v => !!v || "do not empty."],
      email: [v => !!v || "do not empty."]
    },
    snack_model: {
      status: "",
      msg: "",
      type: ""
    }
  }),
  created: function() {
    this.commitSetToolbar({ patternTool: "0" });
    this.commitSetShowLoading(false);
    this.form_model.user_code = localStorage._usercode;
    this.form_model.email = localStorage._email;
  },
  methods: {
    ...mapActions("app", [
      "commitSetToolbar",
      "commitSetShowLoading",
      "getFormatDate"
    ]),
    profileUpdate() {
      console.log("res");
      if (this.form_valid) {
        ProfileService.updateProfile(
          this.form_model.user_code,
          this.form_model.email
        )
          .then(res => {
            console.log(res);
            localStorage._usercode = this.form_model.user_code;
            localStorage._email = this.form_model.email;
            this.snack_model.status = true;
            this.snack_model.msg = "Profile Updated!";
            this.snack_model.type = "success";
          })
          .catch(err => {
            this.snack_model.status = true;
            this.snack_model.msg = err.response.data;
            this.snack_model.type = "error";
          });
      }
    },
    passwordUpdate() {
      if (this.form_valid) {
        if (
          this.password_model.new_password ==
          this.password_model.confirm_password
        ) {
          ProfileService.updatePassword(this.password_model.old_password,this.password_model.new_password)
            .then(res => {
              console.log(res);
              // this.msg ="Passwordของท่านถูกส่งไปที่ Email: " +this.form_model.email +" เรียบร้อยแล้ว";
              this.snack_model.status = true;
              this.snack_model.msg =
                "Reset Password ถูกส่งไปที่ Email: " +
                this.form_model.email +
                " เรียบร้อยแล้ว";
              this.snack_model.type = "success";
            })
            .catch(err => {
              console.log(err);
              // this.msg = "ไม่พบ Email: "+this.form_model.email +" ในระบบ",
              this.snack_model.status = true;
              this.snack_model.msg =
                err+",หรือรหัสผ่านไม่ตรงกัน";
              // this.snack_model.msg = err;
              this.snack_model.type = "error";
            });
        } else {
          this.snack_model.status = true;
          this.snack_model.msg =
            "ยืนยันรหัสผ่านไม่ตรงกัน";
          this.snack_model.type = "error";
        }
      }
    }
  }
};
</script>
